import { render } from "./CutiView.vue?vue&type=template&id=00206e72"
import script from "./CutiView.vue?vue&type=script&lang=js"
export * from "./CutiView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__